/**
 * @generated SignedSource<<228aa8c55cf64ee372eb72e6294efad9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ProfileContactInfo_tradeFirm$data = {
  readonly publicProfile: {
    readonly email: string | null;
  } | null;
  readonly serviceId: string | null;
  readonly " $fragmentType": "ProfileContactInfo_tradeFirm";
};
export type ProfileContactInfo_tradeFirm$key = {
  readonly " $data"?: ProfileContactInfo_tradeFirm$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProfileContactInfo_tradeFirm">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProfileContactInfo_tradeFirm",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "serviceId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "TradeFirmPublicProfileType",
      "kind": "LinkedField",
      "name": "publicProfile",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "email",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "TradeFirmType",
  "abstractKey": null
};

(node as any).hash = "767bb6c0bc548e855e504204b61d7e70";

export default node;
